import { render, staticRenderFns } from "./SettingsForms.vue?vue&type=template&id=1670453d&scoped=true"
import script from "./SettingsForms.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsForms.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SettingsForms.vue?vue&type=style&index=0&id=1670453d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670453d",
  null
  
)

export default component.exports